/**
 * General error model
 */
export class ErrorDetails {
  code: string;
  parameters: { [key: string]: '', };
}
